import { render } from "./Headerv2.vue?vue&type=template&id=358065d5&scoped=true"
import script from "./Headerv2.vue?vue&type=script&lang=js"
export * from "./Headerv2.vue?vue&type=script&lang=js"

import "./Headerv2.vue?vue&type=style&index=0&id=358065d5&scoped=true&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358065d5"]])

export default __exports__